import { createGlobalStyle } from 'styled-components';
import { device } from './devices';
import { COLORS } from './variables';
import AudiFonts from './fonts';
import { GlobalReset } from './reset';

const GlobalStyles = createGlobalStyle`
  ${device}
  ${GlobalReset}
  ${AudiFonts}
  ${COLORS}
`;

export default GlobalStyles;
